import { render, staticRenderFns } from "./courseevents.vue?vue&type=template&id=1dd8c194&scoped=true"
import script from "./courseevents.vue?vue&type=script&lang=js"
export * from "./courseevents.vue?vue&type=script&lang=js"
import style0 from "./courseevents.vue?vue&type=style&index=0&id=1dd8c194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8c194",
  null
  
)

export default component.exports